import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { CgCPlusPlus } from 'react-icons/cg';
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiHtml5,
} from 'react-icons/di';
import { SiFirebase, SiNextDotJs,SiMysql } from 'react-icons/si';

function Techstack() {
  return (
    <Row style={{ justifyContent: 'center', paddingBottom: '50px' }}>
      <Col xs={4} md={2} className="tech-icons">
        <CgCPlusPlus />
        <p style={{ fontSize: '1.1rem' }}>C/C++</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiJavascript1 />
        <p style={{ fontSize: '1.1rem' }}>JavaScript</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
        <p style={{ fontSize: '1.1rem' }}>ReactJs</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiNextDotJs />
        <p style={{ fontSize: '1.1rem' }}>Next.Js</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
        <p style={{ fontSize: '1.1rem' }}>HTML5/CSS3</p>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiNodejs />
        <p style={{ fontSize: '1.1rem' }}>NodeJs</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
        <p style={{ fontSize: '1.1rem' }}>MySQL</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMongodb />
        <p style={{ fontSize: '1.1rem' }}>MongoDB</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
        <p style={{ fontSize: '1.1rem' }}>Python</p>
      </Col>

      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
        <p style={{ fontSize: '1.1rem' }}>Git</p>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiFirebase />
        <p style={{ fontSize: '1.1rem' }}>Firebase</p>
      </Col>
    </Row>
  );
}

export default Techstack;
